import { render, staticRenderFns } from "./PopupNotifications.vue?vue&type=template&id=60770e64&scoped=true"
import script from "./PopupNotifications.vue?vue&type=script&lang=ts"
export * from "./PopupNotifications.vue?vue&type=script&lang=ts"
import style0 from "./PopupNotifications.vue?vue&type=style&index=0&id=60770e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60770e64",
  null
  
)

export default component.exports